export default "__VITE_ASSET__DylEL5Ce__"